<template lang="html">
  <div class="ai-dialog" :class="{'ai-dialog--visible': visible}">
    <transition name="fade">
      <div v-if="visible"
           class="ai-hover"
           @click="closeBGDialog"
      />
    </transition>
    <transition name="top-fade">
      <div v-if="visible" class="ai-dialog__frame" :style="style">
        <div v-if="$slots.header" class="ai-dialog-header">
          <div class="ai-dialog-header__content">
            <slot name="header" />
          </div>
          <img class="ai-dialog-header__close" :src="require('./close.svg')" @click="closeDialog">
        </div>
        <div class="ai-dialog-content">
          <slot />
        </div>
        <div v-if="$slots.footer" class="ai-dialog-footer">
          <slot name="footer" />
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
/* eslint-disable */
export default {
  name: 'AiDialog',
  props: {
    width: {
      type: String,
      default: null
    },
    height: {
      type: String,
      default: null
    },
    visible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {};
  },
  computed: {
    style() {
      const style = {};
      if (this.width) {
        style.width = Number.isNaN(Number(this.width)) ? this.width : `${Number(this.width)}px`;
      }
      if (this.height) {
        style.height = Number.isNaN(Number(this.height)) ? this.height : `${Number(this.height)}px`;
      }
      return style;
    }
  },
  methods: {
    closeDialog() {

      this.$emit('close');
    },
    closeBGDialog() {
    },
    removeNode() {
      this.$destroy(true);
      this.$el.parentNode.removeChild(this.$el);
    }
  }
};
</script>
